import { useUpdateGoal } from 'features/goals';
import { useUpdateLifeArea } from 'features/life-areas';
import { useCallback } from 'react';
import { rootId } from 'shared/components/ui/virtualized-tree-list';
import { UpdateGoal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { GoalSortingMode } from 'shared/types/sorting-mode';

export const useGoalTreeReorder = (lifeAreaId: ID) => {
  const { submit: updateGoal } = useUpdateGoal();
  const { submit: updateLifeArea } = useUpdateLifeArea();

  return useCallback(
    (
      updatedSections: { id: ID; goalSorting: ID[] }[],
      updatedGoals: UpdateGoal[],
    ) => {
      // update goals
      updatedGoals.forEach((goal) => updateGoal(goal));

      updatedSections.forEach(({ id, goalSorting }) => {
        if (id === rootId) {
          updateLifeArea({
            id: lifeAreaId,
            goalSorting,
            goalSortingMode: GoalSortingMode.Custom,
          });
          return;
        }
        updateLifeArea({
          id,
          goalSorting,
          goalSortingMode: GoalSortingMode.Custom,
        });
      });
    },
    [lifeAreaId, updateGoal, updateLifeArea],
  );
};
